(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["raynaud-buy-box"] && !Shopify.designMode) return;
  try {
    
  /* Thumbnail image switcher */
  const thumbs = document.querySelectorAll('.raynaud-buybox__thumb');
  const mainImg = document.querySelector('.raynaud-buybox__img');
  for (const thumb of thumbs) {
    thumb.addEventListener('click', function() {
      const url = this.dataset.imageUrl;
      if (mainImg && url) {
        mainImg.src = url;
        for (const t of thumbs) {
          t.classList.remove('raynaud-buybox__thumb--active');
        }
        this.classList.add('raynaud-buybox__thumb--active');
      }
    });
  }

  /* Variant option selector */
  const optionBtns = document.querySelectorAll('.raynaud-buybox__option-btn');
  const variantSelect = document.getElementById('raynaud-variant-select');
  
  for (const btn of optionBtns) {
    btn.addEventListener('click', function() {
      const optionName = this.dataset.optionName;
      const siblings = document.querySelectorAll(`[data-option-name="${optionName}"]`);
      for (const sib of siblings) {
        sib.classList.remove('raynaud-buybox__option-btn--active');
      }
      this.classList.add('raynaud-buybox__option-btn--active');

      /* Update selected label */
      const label = this.closest('.raynaud-buybox__option-group')
        ?.querySelector('.raynaud-buybox__option-selected');
      if (label) label.textContent = this.dataset.optionValue;

      /* Build variant title from all active options and match */
      const activeOptions = [];
      const groups = document.querySelectorAll('.raynaud-buybox__option-group');
      for (const group of groups) {
        const active = group.querySelector('.raynaud-buybox__option-btn--active');
        if (active) activeOptions.push(active.dataset.optionValue);
      }
      
      const variantTitle = activeOptions.join(' / ');
      
      if (variantSelect) {
        Array.from(variantSelect.options).forEach(opt => {
          if (opt.text.includes(variantTitle)) {
            variantSelect.value = opt.value;
            
            /* Met à jour le prix sur le bouton s'il existe */
            const price = opt.dataset.price;
            const atcText = document.querySelector('.raynaud-buybox__atc .t4s-btn-atc_text');
            if(atcText && price) {
              atcText.innerHTML = `Ajouter au panier — ${price}`;
            }
          }
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["revixx-advertorial"] && !Shopify.designMode) return;
  try {
    

class RevixxAdvertorial extends HTMLElement {
  #sticky = null;
  #visible = false;

  connectedCallback() {
    this.#sticky = document.querySelector('[data-rv-sticky]');
    if (!this.#sticky) return;
    window.addEventListener('scroll', this.#onScroll.bind(this), { passive: true });
    this.#onScroll();
  }

  #onScroll() {
    const show = (window.scrollY || window.pageYOffset) > 400;
    if (show === this.#visible) return;
    this.#visible = show;
    if (show) {
      this.#sticky.style.display = 'block';
      this.#sticky.removeAttribute('aria-hidden');
    } else {
      this.#sticky.style.display = 'none';
      this.#sticky.setAttribute('aria-hidden', 'true');
    }
  }
}
customElements.define('revixx-advertorial-el', RevixxAdvertorial);
document.querySelector('.rv-page')?.setAttribute('is', 'revixx-advertorial-el');

// Init simple sans custom element pour compatibilité max
(function(){
  var sticky = document.querySelector('[data-rv-sticky]');
  if (!sticky) return;
  sticky.style.display = 'none';
  window.addEventListener('scroll', function(){
    var y = window.scrollY || window.pageYOffset;
    if (y > 400) {
      sticky.style.display = 'block';
      sticky.removeAttribute('aria-hidden');
    } else {
      sticky.style.display = 'none';
      sticky.setAttribute('aria-hidden','true');
    }
  }, { passive: true });
})();


  } catch(e) { console.error(e); }
})();
})();
